<template>
  <section :class="wrapperClasses">
    <div class="full-page-wrapper__header">
      <slot name="back">
        <v-btn icon 
          class="full-page-wrapper__header__back"
          @click="$router.push('/')">
          <v-icon class="grey--text text--darken-2">keyboard_backspace</v-icon>
        </v-btn>
      </slot>
      <slot name="header"><h2 class="title">Full Page Header</h2></slot>
    </div>
    <div class="full-page-wrapper__content px-3">
      <slot></slot>
    </div>
  </section>
</template>

<script>
  let FullPageWrapper = {
    components: {},
    data() {
      return {
        wrapperClasses: {
          'full-page-wrapper': true,
          'full-page-wrapper--vert': this.verticalCenter
        }
      }
    },
    props: {
      verticalCenter: Boolean
    }
  }

  export default FullPageWrapper
</script>

<!-- <style lang="stylus">
  @import "~stylus/variables"; -->

<style>
  .full-page-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    z-index: 2;
    position: fixed;
    top: 0;
    width: 100vw;
    background-color: rgba(88, 88, 88, 0.9);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0px;
    padding-top: 10px;
    margin-top: 64px;
    height: 100%;
  }
  
  .full-page-wrapper__header {
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 30px;
    color: white;
    background-color: #222222;
    padding-top: 30px !important;
  }
  
  .full-page-wrapper__header__back {
    position: absolute !important;
    left: 25px;
    top: 55px;
  }
  
  .full-page-wrapper--vert {
    justify-content: center;
    /*padding-bottom: 20vh !important;*/
  }
  
  .full-page-wrapper__header {
    text-align: center;
    text-transform: uppercase;
  }
  
  .full-page-wrapper__content {
    box-sizing: border-box;
    /*max-width: 650px;*/
    width: 100%;
    margin: 0 auto;

  }

.full-page-wrapper ::-webkit-scrollbar {
    width: 15px;
    }

.full-page-wrapper ::-webkit-scrollbar-track {
      background: #f1f1f1;
      box-shadow: inset 0 0 5px grey; 
    }

.full-page-wrapper ::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, .75); 
    } 
  
  @media (max-width: $xs-screen-breakpoint) {
    .full-page-wrapper__header__back {
      margin-top: -5px;
      margin-left: 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/FullPageWrapper/FullPageWrapper.vue